import { Home, Users, Calendar, MessageSquare, BarChart3 } from 'lucide-react'

interface MentorBottomNavProps {
    activeTab: string
    setActiveTab: (tab: string) => void
}

const navItems = [
    { id: 'dashboard', label: 'Home', icon: Home },
    { id: 'students', label: 'Students', icon: Users },
    { id: 'plan-builder', label: 'Plan', icon: Calendar },
    { id: 'chat', label: 'Chat', icon: MessageSquare, badge: 3 },
    { id: 'analytics', label: 'Analytics', icon: BarChart3 },
]

export function MentorBottomNav({ activeTab, setActiveTab }: MentorBottomNavProps) {
    return (
        <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800 safe-bottom">
            <div className="grid grid-cols-5 h-16">
                {navItems.map((item) => {
                    const Icon = item.icon
                    const isActive = activeTab === item.id

                    return (
                        <button
                            key={item.id}
                            onClick={() => setActiveTab(item.id)}
                            className={`flex flex-col items-center justify-center gap-1 relative transition-colors ${isActive
                                    ? 'text-primary-blue'
                                    : 'text-slate-400 dark:text-slate-500'
                                }`}
                        >
                            <Icon className="h-5 w-5" />
                            <span className="text-xs font-medium">{item.label}</span>
                            {item.badge && (
                                <span className="absolute top-2 right-1/4 w-4 h-4 bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center">
                                    {item.badge}
                                </span>
                            )}
                            {isActive && (
                                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-12 h-1 bg-primary-blue rounded-b-full" />
                            )}
                        </button>
                    )
                })}
            </div>
        </div>
    )
}
